mutation UserMessageUnreadCountReminderUpdate ($input: UserMessageUnreadCountReminderUpdateInput!) {
  userMessageUnreadCountReminderUpdate(
   input: $input
  ) {
    clientMutationId
    _NewUserMessageCounts
  }
}